import React, { Fragment } from 'react'
import PaginatedConnectionTable from 'components/PaginatedConnectionTable'
import graphqlQuery from 'graphs/queries/CompaniesPaginated.graphql'
import withConnectionQuery from 'components/withConnectionQuery'
import fields from 'fields/companies'

const RouteCompanies = props => (
  <Fragment>
    <h3>Companies</h3>
    <PaginatedConnectionTable {...props} fields={fields} showNew />
  </Fragment>
)

export default withConnectionQuery({
  graphqlQuery,
  paginated: true,
  namespace: 'companies'
})(RouteCompanies)



// WEBPACK FOOTER //
// ./src/routes/admin/companies/index.js